module.exports = __webpack_public_path__ + "img/Impact characterisation - Cumulative.197ebb49.svg";